import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import { Input, Button } from 'common/components';
import { email, required } from 'common/form-validators';

const ForgotPasswordForm = ({
  onSubmit,
  error,
  handleSubmit,
  valid,
  pristine,
  submitting,
}) => {
  return (
    <Fragment>
      <form onSubmit={handleSubmit(onSubmit)} className="auth__form">
        <Input
          name="forgotPasswordEmail"
          disabled={submitting}
          title="Email"
          validate={[email, required]}
        />

        {error && <div className="auth__form-error">{error}</div>}

        <div className={'field__group text--center'}>
          <Button
            type="submit"
            className="btn btn--primary"
            disabled={!valid || pristine || submitting}
          >
            SEND RESET LINK
          </Button>
        </div>
      </form>
    </Fragment>
  );
};

ForgotPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,

  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

const WithFormForgotPassword = reduxForm({
  form: 'forgotPassword', // a unique identifier for this form
})(ForgotPasswordForm);

export default WithFormForgotPassword;



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/ForgotPasswordForm.js